module.exports = __webpack_public_path__ + "static/grundschule-72351623276ca038ae0914162b18b5cc.PNG";